import React, { useState } from "react"; // Import useState
import PropTypes from "prop-types";
import styles from "./RefundConfirmationModal.module.css";
import { Modal } from "shared/Modal";
import classNames from "classnames";
import Loader from "shared/Loader";

/**
 * Modal that opens when the user clicks the refund button for a ticket.
 */

export function RefundConfirmationModal({
  isOpen,
  onCollapse,
  onClose,
  onClick,
  isLoading,
  refundCompleted,
  refundMessage,
  refundMessageType,
  ticketCost,
  ticketPriceType,
  isLocalFunction,
}) {
  const [applyFee, setApplyFee] = useState(false);
  // const alertClasses = {
  //   success: "success", // These should match your CSS classes for alerts
  //   error: "danger",
  // };
  const renderRefundMessage = () => {
    // Dynamically setting class names based on the message type
    const alertClass =
      refundMessageType === "success" ? styles.success : styles.danger; // Adjust to use CSS module references

    return (
      <div className={alertClass} role="alert">
        {refundMessage}
      </div>
    );
  };
  // const [updatefundMessage, setRefundMessage] = useState(refundMessage);
  // const [refundMessageType, setRefundMessageType] = useState("success");
  const handleRefundClick = () => {
    onClick(applyFee);
  };
  const handleClose = () => {
    // Reset applyFee if the refundMessageType is error
    if (refundMessageType === "error") {
      setApplyFee(false);
      // setRefundMessage("");
    }

    if (onClose) {
      onClose();
    } else {
      onCollapse();
    }
  };

  return (
    <div className={styles.container}>
      <Modal
        title={
          isLocalFunction
            ? ticketPriceType == "REDEEM CREDITS"
              ? "CANCEL CONFIRMATION"
              : "REFUND CONFIRMATION"
            : ticketCost <= 0
            ? "CANCEL CONFIRMATION"
            : "REFUND CONFIRMATION"
        }
        isOpen={isOpen}
        onClose={handleClose}
        className={styles.modal}
      >
        <>
          {isLoading ? (
            <Loader />
          ) : refundCompleted ? (
            <div>{refundMessage && renderRefundMessage()}</div>
          ) : (
            <>
              {ticketCost !== 0 && !isLocalFunction && (
                <>
                  <label className={styles.label}>
                    Apply cancellation fee:
                  </label>
                  <input
                    type="checkbox"
                    checked={applyFee}
                    onChange={() => setApplyFee(!applyFee)}
                  />
                </>
              )}
              <div className={styles.confirm}>
                Are you sure you want to{" "}
                {isLocalFunction
                  ? ticketPriceType == "REDEEM CREDITS"
                    ? "cancel"
                    : "refund"
                  : ticketCost == 0
                  ? "cancel"
                  : "refund"}{" "}
                this ticket?
              </div>
              <div>
                <button
                  className={classNames(styles.button, styles.refundBtn)}
                  onClick={handleRefundClick}
                >
                  {isLocalFunction
                    ? ticketPriceType == "REDEEM CREDITS"
                      ? "CANCEL"
                      : "REFUND"
                    : ticketCost == 0
                    ? "CANCEL"
                    : "REFUND"}
                </button>
                <button className={styles.button} onClick={onCollapse}>
                  CLOSE
                </button>
              </div>
            </>
          )}
        </>
      </Modal>
    </div>
  );
}

RefundConfirmationModal.propTypes = {
  /**
   * Determines if the modal is open
   */
  isOpen: PropTypes.bool,
  /**
   * Function called when cancel is clicked
   */
  onCollapse: PropTypes.func,
  /**
   * Function called when refund is clicked
   */
  onClick: PropTypes.func,
};
